module.exports = __webpack_public_path__ + "static/media/veneto-village-05.ffe19448.jpg";